import { Card, Stack, Typography } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Product, SubscriberProductResponseDto } from '@subflow/api-client';
import { useState } from 'react';
import { useSubdomain } from '@subflow-frontend/sections/subscriber';

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.up(1368)]: {
    padding: theme.spacing(5, 8),
  },
}));

// ----------------------------------------------------------------------

type Props = {
  product: Product | SubscriberProductResponseDto;
};

export default function SubscriptionSimpleDetails({ product }: Props) {
  const [isLoading] = useState(false);
  const { subdomain } = useSubdomain();
  return (
    <RootStyle>
      <Card>
        <Stack spacing={3} mx={3} pb={3}>
          <div></div>
          <Typography variant="h5">{product.name}</Typography>

          <MuiButton
            color="inherit"
            disabled={isLoading}
            variant="contained"
            sx={{ mt: 2 }}
            href={`/sub/${subdomain}/listing/${product.slug}`}
          >
            Back
          </MuiButton>
        </Stack>
      </Card>
    </RootStyle>
  );
}
